import { Feature, IDynamicLoader, Loader } from '@tencent/workbench';
import BaseToolbarFeature from '../../common/feature/base-toolbar-feature';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';
import { SpinOptions } from '@src/framework/workbench/drawer/ui/layout/size/config';
import { ISizeFeature } from '@src/framework/workbench/drawer/ui/layout/size/size-interface';
import { handleInputBlurInitAndReset, IInputParams } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { NumberInputFrom } from '@tencent/wb-ext-form';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

export const WIDTH = 'width';
export const HEIGHT = 'height';
export type IType = 'width' | 'height';

@Feature()
export class SizeWithRatioFeature extends BaseToolbarFeature {
    private tabElement: Element | null;

    public constructor(@Loader(ISizeFeature) private loader: IDynamicLoader<ISizeFeature>) {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.SIZE);
        this.getDrawerInputManager()?.executeInitPropsCallback();
    }


    public initPropsCallback = () => {
        this.sizeFeature.initScaleInfo();
    };

    private get sizeFeature() {
        return this.loader.instance!;
    }

    public getHeight() {
        const heightObj = { height: this.sizeFeature.height };
        const height = this.sizeFeature.getShownValue(INPUT_PROPS_CALLBACK_KEY.SIZE, heightObj);
        return this.sizeFeature.modifyShownValue(height, SpinOptions.toFixed);
    }

    public getWidth() {
        const widthObj = { width: this.sizeFeature.width };
        const width = this.sizeFeature.getShownValue(INPUT_PROPS_CALLBACK_KEY.SIZE, widthObj);
        return this.sizeFeature.modifyShownValue(width, SpinOptions.toFixed);
    }

    public getAspectRatio() {
        return this.sizeFeature.size?.noChangeAspectType;
    }

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.SIZE)
    public handleHeightChange(value, from) {
        const height = this.sizeFeature.getChangeVal(value, HEIGHT, from === NumberInputFrom.INPUT);
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel).getFrame?.()
            ?.updateHeight({ value: height });
    }
    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.SIZE)
    public handleWidthChange(value, from) {
        const width = this.sizeFeature.getChangeVal(value, WIDTH, from === NumberInputFrom.INPUT);
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel).getFrame?.()
            ?.updateWidth({ value: width });
    }

    public changeAspectRatio = (value) => {
        this.sizeFeature.handleLocksChange(value);
    };

    public getDrawerInputManager = () => this.getAppService().editableServiceLayer
        ?.drawerInputManager.dangerousInstance;

    public getInputParams(): IInputParams {
        return {
            key: INPUT_PROPS_CALLBACK_KEY.SIZE,
        };
    }

    public handleNumberInputBlur = () => {
        this.getDrawerInputManager()?.setInputFocus(false);
        this.tabElement?.removeEventListener('keydown', this.handleInputEnter);
    };

    public handleNumberInputFocus = () => {
        this.getDrawerInputManager()?.setInputFocus(true);
        this.tabElement = document.getElementById('toolbar-button-size_with_ratio');
        this.tabElement?.addEventListener('keydown', this.handleInputEnter);
    };

    public getSelectModel() {
        // toUpateModel的更新时机在PropertyEditorManager中，通过监听选中元素的变更来更新
        // 但可能出现比如页面刚加载时，选中元素打开侧边栏，但由于PropertyEditorManager是异步加载还未注册监听事件，导致toUpateModel为undefined
        if (!this.getDrawerInputManager()?.toUpateModel) {
            this.getDrawerInputManager()?.updateCurrentModel(this.getAppService()
                .viewableServiceLayer.selectionService.getSelectedModel());
        }
        return this.getDrawerInputManager()?.toUpateModel;
    }


    private handleInputEnter = (event: KeyboardEvent) => {
        if ((event.keyCode === 13 || event.which === 13) && (event.target as HTMLElement).tagName === 'INPUT') {
            event.preventDefault();
            // 全选输入框的内容
            (event.target as HTMLInputElement).select();
            this.getDrawerInputManager()?.forceUpdateInput();
        }
    };

    private addInitPropsCallback = (key: string) => {
        this.getDrawerInputManager()?.addInitPropsCallback(key, this.initPropsCallback);
    };
}
